import { readAsDataUrl } from '../../../app-core/lib/file/read'

export async function Imag_readDataURIFromFileAndDelete(url: string) {
    const { file, fileEntry } = await resolveLocalFile(url)
    const contents = await readAsDataUrl(file)
    await removeFileEntry(fileEntry)
    return contents
}

export async function resolveLocalFile(url: string) {
    const entry = await new Promise<Entry>((resolve, reject) => {
        window.resolveLocalFileSystemURL(url, resolve, reject)
    })

    const fileEntry = entry as FileEntry
    const file = await new Promise<File>((resolve, reject) => fileEntry.file(resolve, reject))

    return { fileEntry, file }
}

export async function removeFileEntry(fileEntry: FileEntry) {
    await new Promise<void>((resolve, reject) => fileEntry.remove(resolve, reject)).catch(() => null)
}
